// src/pages/SettingsPage.js
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  People as PeopleIcon,
  Shield as ShieldIcon,
  VpnKey as VpnKeyIcon,
} from "@mui/icons-material";
import UserManagement from "../components/settings/UserManagement";
import RoleManagement from "../components/settings/RoleManagement";
import PermissionManagement from "../components/settings/PermissionManagement";

const SettingsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();
  
  const getActiveTab = () => {
    if (location.pathname.includes("/settings/roles")) return 1;
    if (location.pathname.includes("/settings/permissions")) return 2;
    return 0;
  };

  const [activeTab, setActiveTab] = useState(getActiveTab());

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    switch (newValue) {
      case 0:
        navigate("/settings");
        break;
      case 1:
        navigate("/settings/roles");
        break;
      case 2:
        navigate("/settings/permissions");
        break;
      default:
        navigate("/settings");
    }
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 1400, mx: "auto" }}>
      <Typography
        variant="h4"
        fontWeight={800}
        sx={{
          mb: 1,
          fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2rem" },
          background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Configuración
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4, fontSize: { xs: "0.875rem", sm: "1rem" } }}
      >
        Gestiona usuarios, roles y permisos del sistema
      </Typography>

      <Card
        elevation={0}
        sx={{
          borderRadius: { xs: "16px", sm: "24px" },
          border: "1px solid",
          borderColor:
            theme.palette.mode === "dark"
              ? "rgba(255,255,255,0.12)"
              : "#e2e8f0",
          background: theme.palette.background.paper,
          overflow: "hidden",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant={isMobile ? "fullWidth" : "standard"}
          sx={{
            px: { xs: 1, sm: 3 },
            pt: 2,
            borderBottom: "1px solid",
            borderColor: theme.palette.divider,
            "& .MuiTab-root": {
              color: theme.palette.text.secondary,
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              minWidth: { xs: "auto", sm: 120 },
              px: { xs: 1, sm: 3 },
              py: 2,
              textTransform: "none",
              fontWeight: 600,
              "&.Mui-selected": {
                color: theme.palette.primary.main,
              },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: theme.palette.primary.main,
              height: 3,
              borderRadius: "3px 3px 0 0",
            },
          }}
        >
          <Tab
            icon={<PeopleIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />}
            iconPosition="start"
            label="Usuarios"
          />
          <Tab
            icon={<ShieldIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />}
            iconPosition="start"
            label="Roles"
          />
          <Tab
            icon={<VpnKeyIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />}
            iconPosition="start"
            label="Permisos"
          />
        </Tabs>

        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          {activeTab === 0 && <UserManagement />}
          {activeTab === 1 && <RoleManagement />}
          {activeTab === 2 && <PermissionManagement />}
        </CardContent>
      </Card>
    </Box>
  );
};

export default SettingsPage;